import { ReactNode } from "react";
import useCoordinatorReport2Data, {
  CoordinatorReport2DataContext,
} from "./useCoordinatorReport2Data";

export interface CoordinatorReport2DataProviderProps {
  children?: ReactNode;
}

const CoordinatorReport2DataProvider: React.FC<
  CoordinatorReport2DataProviderProps
> = ({ children }) => {
  const context = useCoordinatorReport2Data();

  return (
    <CoordinatorReport2DataContext.Provider value={context}>
      {children}
    </CoordinatorReport2DataContext.Provider>
  );
};
export default CoordinatorReport2DataProvider;
